import { ValidationError } from "sequelize"
import {
    MarkovStartvector,
    MarkovStartvectorCreate,
    MarkovStartvectorSave,
} from "server/models"
import { ASC } from "const"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import { MarkovStartvectorValidation } from "./types"


export const LoadAllMarkovStartvectors = (modelId: number) => (
    GET(`/markovStartvector/modelId/${modelId}`)
    .then((startvectors: MarkovStartvector[]) => (
        startvectors.sort((a, b) => sort(a, b, "order", ASC))
    ))
)

export const LoadMarkovStartvectorById = (startvectorId: number, modelId: number) => (
    GET(`/markovStartvector/id/${startvectorId}/modelId/${modelId}`)
    .then((startvector: MarkovStartvector) => startvector)
)

export const SaveMarkovStartvector = (
    id: number,
    startvector: MarkovStartvectorCreate,
    lang: LangType,
) => {
    const data: MarkovStartvectorSave = {
        id,
        startvector,
    }
    return POST(
        "/markovStartvector/save",
        JSON.stringify(data),
    ).then((res) => {
        const newStartvector = res as MarkovStartvector
        const error = res as ValidationError

        return {
            newStartvectorId: newStartvector.id || null,
            validation: <MarkovStartvectorValidation>validate(error, lang),
        }
    })
}

export const DeleteMarkovStartvector = (startvectorId: number, modelId: number) => (
    DELETE(`/markovStartvector/delete/${startvectorId}/${modelId}`)
    .then((removedRows: number) => removedRows)
)
